import React, { Component } from "react";
import styled from "styled-components";
import { A, ACSS, Box, Button, H6, IconBook, IconFacebook, IconTwitter, Small } from "@upsolve/ui";

import Page from "./Page.div";
import AboutPanel from "./AboutPanel";
import LearnListingPanel from "../Learn/LearnListingPanel";

class Footer extends Component {
  render() {
    const { bio = true } = this.props;
    return (
      <div>
        {this.props.showArticles === true && <LearnListingPanel />}
        {bio !== false && <AboutPanel />}
        <FooterContainer>
          <div className="footer__directory">
            <div>
              <H6 as="label">Upsolve</H6>
              <ul>
                <li>
                  <a aria-busy="false" href="/team/">
                    Team
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/press/">
                    Press
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/donate/">
                    Donate
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/careers/">
                    Careers
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/policy-platform/">
                    Policy Platform
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/rohan-story/">
                    Our Story
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/get-in-touch/">
                    Contact Us
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <H6 as="label">Need help?</H6>
              <ul>
                <li>
                  <a aria-busy="false" href="/learn/">
                    Learning Center
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/browse/">
                    Browse Articles and Pages
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/legal-definitions/">
                    Legal Definitions
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <H6 as="label">Policies & Privacy</H6>
              <ul>
                <li>
                  <a aria-busy="false" href="/terms-of-service/">
                    Terms of Service
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/terms-of-use/">
                    Terms of Use
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/privacy-policy/">
                    Privacy Policy
                  </a>
                </li>
                <li>
                  <a aria-busy="false" href="/editorial-policy/">
                    Editorial Policy
                  </a>
                </li>
              </ul>
            </div>
            <div>
              <H6 as="label">Made in NYC 🗽</H6>
              <ul>
                <StyledSocialListItem>
                  <IconFacebook />{" "}
                  <A href="https://www.facebook.com/upsolvebankruptcy/" target="_blank" rel="noreferrer noopener">
                    Facebook
                  </A>
                </StyledSocialListItem>
                <StyledSocialListItem>
                  <IconTwitter />{" "}
                  <A href="https://twitter.com/upsolvebk/" target="_blank" rel="noreferrer noopener">
                    Twitter
                  </A>
                </StyledSocialListItem>
                <StyledSocialListItem>
                  <IconBook />{" "}
                  <A href="https://youtube.com/upsolve" target="_blank" rel="noreferrer noopener">
                    Youtube
                  </A>
                </StyledSocialListItem>
                <StyledSocialListItem>
                  <A href="https://www.charitynavigator.org/ein/821736267" target="_blank" rel="noreferrer noopener">
                    Charity Navigator
                  </A>
                </StyledSocialListItem>
                <StyledSocialListItem>
                  <A href="https://www.guidestar.org/profile/82-1736267" target="_blank" rel="noreferrer noopener">
                    Guidestar
                  </A>
                </StyledSocialListItem>
                <li>
                  <b>Mailing Address</b>
                </li>
                <li>150 Court St., 2nd Floor</li>
                <li>Brooklyn, NY 11201</li>
              </ul>
            </div>
          </div>
          <div className="footer__disclaimer">
            <Small>
              © {new Date().getFullYear()} Upsolve. Upsolve Inc., EIN 82-1736267, is a registered nonprofit 501(c)(3)
              organization. Although many of Upsolve’s informational articles are drafted or reviewed by attorneys,
              Upsolve is not a law firm or a substitute for an attorney or law firm. Upsolve provides an online web app
              that helps you file for bankruptcy for free on your own, if you have a simple case and pass our
              eligibility criteria. We{" "}
              <a aria-busy="false" href="/no-legal-advice/">
                do not provide any form of legal advice
              </a>{" "}
              and absolutely no communication between you and Upsolve should be considered legal advice. If you do not
              qualify for our free web app or you do not want to use it, we provide access to private independent
              attorneys at your specific direction. Attorneys pay Upsolve for the chance to provide free evaluations to
              people who ask for them, which{" "}
              <a aria-busy="false" href="/learn/transparency/">
                helps keep our web app free
              </a>
              . By using Upsolve, you do not enter any form of attorney-client relationship with Upsolve. Your access to
              the website is subject to our{" "}
              <a aria-busy="false" href="/terms-of-use/">
                Terms of Use
              </a>
              .
            </Small>
          </div>
        </FooterContainer>
      </div>
    );
  }
}

const StyledSocialListItem = styled.li`
  svg {
    height: 12px;
    width: 12px;
    path {
      fill: ${(props) => props.theme.colors.brand[500]};
    }
  }
`;

const FooterContainer = styled.footer`
  background: ${(props) => props.theme.colors.brand[900]};
  & > div {
    max-width: 960px;
    width: 100%;
    margin: 0 auto;
  }
  & > div.footer__directory {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 1em 2.5em;
    padding: 4em 1em 1em;
    & > div:not(:last-of-type) {
      border-right: 1px solid ${(props) => props.theme.colors.brand[800]};
    }
    li {
      margin-bottom: 6px;
    }
    li,
    p {
      font-size: 0.8em;
    }
    a {
      ${ACSS}
      font-size: 14px;
    }
    @media screen and (max-width: ${(props) => props.theme.breakpoints[500]}) {
      grid-template-columns: 1fr;
      & > div:not(:last-of-type) {
        border-right: none;
        border-bottom: 1px solid ${(props) => props.theme.colors.brand[800]};
      }
      li {
        font-size: 1em;
        padding-bottom: 0.25em;
      }
    }
  }
  & > div.footer__disclaimer {
    line-height: 120%;
    padding: 1em 0.25em 4em;
    &,
    small,
    a,
    a:visited,
    a:active,
    a:hover {
      color: ${(props) => props.theme.colors.gray[700]};
    }
    a,
    a:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  }
`;

export default Footer;
